// require all svg-files here
// it's entry point in webpack config
require('./normacs-logo.svg');
require('./loupe.svg');
require('./user.svg');
require('./settings.svg');
require('./dots.svg');
require('./filter.svg');
require('./dictionary.svg');
require('./document.svg');
require('./document_without-text.svg');
require('./document--text.svg');
require('./document--scan.svg');
require('./document--card.svg');
require('./document--download.svg');
require('./document--package.svg');
require('./cross.svg');
require('./classifiers.svg');
require('./checklists.svg');
require('./question-mark.svg');
require('./except.svg');
require('./checkbox.svg');
require('./checkbox-checked.svg');
require('./memo.svg');
require('./status--active.svg');
require('./status--disabled.svg');
require('./status--na.svg');
require('./status--partly.svg');
require('./status--project.svg');
require('./list.svg');
require('./table.svg');
require('./loader-dots.svg');
require('./arrow-sides.svg');
require('./arrow-updown.svg');
require('./chevron.svg');
require('./flag.svg');
require('./favorite.svg');
require('./draggable.svg');
require('./sort-desc.svg');
require('./sort-asc.svg');
require('./plus.svg');
require('./comments.svg');
require('./table-of-contents.svg');
require('./thumbnails.svg');
require('./timeline.svg');
require('./drawings.svg');
require('./document--canceled.svg');
require('./catalog-lists.svg');
require('./history.svg');
require('./share.svg');
require('./document--compare.svg');
require('./revisions.svg');
require('./attachments.svg');

// require.context('.', true); // why it doesn't work?
